import * as React from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ModalBody } from "reactstrap";
import { Button } from "reactstrap";
import { ModalFooter } from "reactstrap";
import { ModalHeader } from "reactstrap";
import { Field, getFormValues, InjectedFormProps, reduxForm } from "redux-form";
import {SelectButtonFieldOptions,SelectField,TextField} from "common-fields";
import { toast } from "react-toastify";
import { catchError } from "../../../utils/Utils";
import Service from "../../../services";
import validate from "../../../Validate/Validate";
import { BankUserContext } from "../../../bankUserContext";


export interface urlType {
  id: number;
  text: string;
  value: string;
  url: string;
  roleId: string;
  pageLinkUuid: string | null;
}

// eslint-disable-next-line @typescript-eslint/ban-types
const ShortcutForm: React.FC<any & InjectedFormProps<{}, any>> = (
  props: any
) => {
  const appType = [
    {
      value: 17,
      text: "In App",
    },
    {
      value: 18,
      text: "External",
    },
  ];
  const service = new Service();
  const [urlLists, setUrlList] = useState<urlType[]>([]);
  const [loader, setLoader] = useState(false);
  const [typeLayout, setLayOut] = useState<boolean>(false);
  const context=React.useContext(BankUserContext);
  useEffect(() => {
    if (props.type == 2) {
      setLayOut(true);
    }
    const getQuickLinks = {
      screen: "LandingPage",
    
      sections: "getQuickLinks",
    
      userId: context?.bankuserDetails?.userId,
    
      roleId: context?.bankRolesData?.roleId,
    };
    
    service.getQuickLinks(getQuickLinks).then((response: any) => {
      if(response.data){
        setUrlList(
          response.data?.map((element: any) => {
            return {
              id: element.quick_links_id,
              text: element.name,
              value: element.name,
              url: element.url,
              roleId: element.role_id,
              pageLinkUuid: element.pageLinkUuid,
            };
          })
        );
      }else{
        setUrlList([])
      }
      
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeType = (e: any) => {
    if (e == "17") {
      setLayOut(false);
      props.change("name", props?.name);
      props.change("url", props?.url);
    } else {
      setLayOut(true);
      props.change("name", null);
      props.change("url", null);
    }
  };
  const addShortcut = () => {
    let body = {};
    if (!typeLayout) {
      const urlObject = urlLists.find(
        (element: any) => element.value == props.formValues.name
      );
      body = {   
        screen: "LandingPage",
        sections: "UserQuickLink",     
       data:{
        type: 1,
        userId: context.bankuserDetails?.userId,
        name: urlObject?.text,
        url: urlObject?.url,
        userQuickLinksId: props?.userQuickLinksId, 
        displaySequence:1,
       }       
      };
    } else {
      body = {
        screen: "LandingPage",
        sections: "UserQuickLink", 
        data:{
          type: 2,
          name: props.formValues.name,
          userId: context.bankuserDetails?.userId,
          url: props.formValues.url,
          userQuickLinksId: props?.userQuickLinksId,
          displaySequence:1
        }       
      };
    }
    setLoader(true);
    service
      .createUserShortcut(body)
      .then(() => {
        toast.success(
          `${
            props.userQuickLinksId
              ? `${"Shortcut Updated"}`
              : `${"Shortcut Created"}`
          }`,
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
        setLoader(false);
        props.setRefreshShortcuts(true);
        setTimeout(() => {
          props.closeToggle();
        }, 2000);
      })
      .catch((error: any) => {
        catchError(error, true);
        setLoader(false);
      });
  };
  const { invalid } = props;
  return (
    <div className="shortcutForm">
      <ModalHeader toggle={props?.toggle()}>
        {props.userQuickLinksId ? "Edit Quick Link" : "New Quick Link"}
      </ModalHeader>
      <ModalBody>
        <form className="form-group">
          <div>
            <Field
              component={SelectButtonFieldOptions}
              name={"question1"}
              label={""}
              // helpText={""}
              options={appType}
              onChange={(e: any) => {
                onChangeType(e);
              }}
            />
            <div className="inputWrapper">
              <Field
                component={!typeLayout ? SelectField : TextField}
                name={"name"}
                label={`${!typeLayout ? "App Page" : "Quick Link Name"}`}
                // helpText={""}
                values={urlLists}
              />

              <>
                {typeLayout ? (
                  <Field
                    component={TextField}
                    name={"url"}
                    label={"URL"}
                    // helpText={""}
                  />
                ) : null}
              </>
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button
          disabled={invalid}
          pristine
          // color="success"
          className="addUpdateBtn"
          onClick={() => addShortcut()}
        >
          {props.userQuickLinksId ? "Update" : "Add"}
        </Button>{" "}
      </ModalFooter>
    </div>
  );
};

export default connect((state: any, props: any) => {
  return {
    initialValues: {
      question1: props.type == 2 ? 18 : 17,
      name: props?.name,
      url: props?.url,
    },
    formValues: getFormValues("ShortcutForm")(state),
  };
})(
  // eslint-disable-next-line @typescript-eslint/ban-types
  reduxForm<{}, any>({
    form: "ShortcutForm",
    enableReinitialize: true,
    validate,
  })(ShortcutForm)
);
